const getCropperProps = (cropperData: Record<string, any>, ratio = '16:9', articleId: number) => {
  let cropperProps: Record<string, unknown> = {};
  const { focuspoint, customCrops = [] } = cropperData;

  if (focuspoint?.x !== undefined && focuspoint?.x !== null) {
    cropperProps.fx = focuspoint?.x;
  }

  if (focuspoint?.y !== undefined && focuspoint?.y !== null) {
    cropperProps.fy = focuspoint?.y;
  }

  if (customCrops && customCrops.length > 0) {
    customCrops.forEach((props: any) => {
      if (props.ratio === ratio) {
        cropperProps = { ...cropperProps, ...props };
      }
    });
  }

  // Override fx, fy values if focuspoint values are not provided
  if (!focuspoint && articleId < 120000000) {
    cropperProps.fx = 0.5;
    cropperProps.fy = 0.25;
  }

  return cropperProps;
};

export default getCropperProps;
